import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import HomePage          from "./Pages/HomePage";
import TermsandConditions from "./Pages/TermsandConditions";
import PrivacyPolicy      from "./Pages/PrivacyPolicy";
import Header             from "./components/Header";
import Footer             from "./components/Footer";

// ─── Initialise GA once
if (process.env.NODE_ENV === "production") {
  ReactGA.initialize("G-WNR1CE7BQC");
}

// ─── Custom hook that sends a hit whenever the route changes ───
function usePageViews() {
  const location = useLocation();
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);
}

function AppRoutes() {
  usePageViews();
  return (
    <Routes>
      <Route path="/"                element={<HomePage />} />
      <Route path="/terms-conditions" element={<TermsandConditions />} />
      <Route path="/privacy-policy"   element={<PrivacyPolicy />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="flex justify-center items-center flex-col">
      <Router>
        <Header />
        <AppRoutes />
        <Footer />
      </Router>
    </div>
  );
}
